const actions = [
    {
        routeName: 'renewals.editRenewalOffer',
        items: [
            {
                title: 'set up offer letter',
                routeName: 'renewals.editOfferLetter',
            },
            {
                title: 'renewal offer chat',
                routeName: 'renewals.chat',
            },
        ],
    },
];

export default actions;
